var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.answer?.option?.is_free_text)?_c('small',{staticClass:"font-weight-bold"},[_vm._v("\n    Other - "+_vm._s(_vm.answer.answer)+"\n")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }